<template>
  <div>
    <a-drawer
        :title='title'
        :visible="visible"
        v-bind="drawerConfig"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
    >
      <a-form-model ref="ruleForm" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }" :model="form" :rules="rules"
                    v-bind="layout">
        <a-form-model-item v-if="type !== 2 "
                           ref="m_news_category_id"
                           label="新闻分类"
                           prop="m_news_category_id"
                           :help="formErr.m_news_category_id"
                           :validateStatus="
                    !formErr.m_news_category_id || formErr.m_news_category_id == '' ? '' : 'error'
                  "
        >
          <a-select
              v-model="form.m_news_category_id"
              @change="(e) => { formErr.m_news_category_id = ''; } "
              mode="multiple"
              allowClear
              :disabled="editId != '' && editId != undefined"
          >
            <a-select-option
                :value="item.id"
                :key="index"
                v-for="(item, index) in category"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!--                <a-form-model-item-->
        <!--                  ref="category_ids"-->
        <!--                  label="新闻分类"-->
        <!--                  prop="category_ids"-->
        <!--                  :help="formErr.category_ids"-->
        <!--                  :validateStatus="-->
        <!--                    !formErr.category_ids || formErr.category_ids == '' ? '' : 'error'-->
        <!--                  "-->
        <!--                >-->
        <!--                  <a-select-->
        <!--                      v-model="form.category_ids"-->
        <!--                      @change="(e) => { formErr.category_ids = ''; } "-->
        <!--                  >-->
        <!--                    <a-select-option-->
        <!--                        :value="item.id"-->
        <!--                        :key="index"-->
        <!--                        v-for="(item, index) in category"-->
        <!--                    >-->
        <!--                      {{ item.name }}-->
        <!--                    </a-select-option>-->
        <!--                  </a-select>-->
        <!--                </a-form-model-item>-->
        <a-form-model-item ref="a_langset_id" label="网站语种" prop="lang">
          {{ form.lang_name }}
        </a-form-model-item>
        <a-form-model-item ref="use_qc_slug" label="是否适用QC生成URL" prop="use_qc_slug">
          <a-radio-group v-model="form.use_qc_slug" :disabled="disabled">
            <a-radio :value="1"> 是</a-radio>
            <a-radio :value="0"> 否</a-radio>
            <!--                    <a-radio :value="2"> 自定义 </a-radio>-->
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item ref="watermark" label="是否生成水印" prop="watermark">
          <a-radio-group v-model="form.watermark">
            <a-radio :value="1"> 是</a-radio>
            <a-radio :value="0"> 否</a-radio>
            <!--                    <a-radio :value="2"> 自定义 </a-radio>-->
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item ref="release" label="是否发布" prop="release">
          <a-radio-group v-model="form.release">
            <a-radio :value="1"> 是</a-radio>
            <a-radio :value="0"> 否</a-radio>
            <!--                    <a-radio :value="2"> 自定义 </a-radio>-->
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            ref="token"
            label="鉴权Token（多个token可用英文','分割）"
            prop="token"
            v-if="editId != '' && editId != undefined"
        >
          <a-input type="textarea" style="height: 120px"
                   :maxLength=5000
                   v-model="form.token"
                   @change="(e) => { formErr.token=''}"
          />
        </a-form-model-item>

      </a-form-model>
      <div class="drawer-btn">

        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
          确定
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import {submitForm, drawerConfig,} from "@/utils/utils"
import API from "../api";

export default {
  name: "customerForm",
  props: ["visible", "title", "type", "editId", "a_customer_id"],
  data() {
    return {
      drawerConfig,
      form: {
        id: '',
        category_ids: '',
        lang: "",
        use_qc_slug: 1,
        watermark: 0,
        release: 0,
        token: "",
        m_news_category_id: [],
        a_customer_id: "",
        type: ''
      },
      formErr: {
        category_ids: "",
      },
      category: [],
      disabled: false,
      rules: {
        category_ids: [{required: true, message: "请选择新闻分类 ", trigger: "blur"},],
        m_news_category_id: [{required: true, message: "请选择新闻分类 ", trigger: "blur"},],
      },
      layout: {
        labelCol: {span: 4},
        wrapperCol: {span: 14},
      },
    };
  },
  watch: {
    editId: function (a, b) {
      if (a != "") {
        API.service.EDIT_DATA({id: a, a_customer_id: this.a_customer_id}).then(res => {
          this.form = res.data.data.info
          this.form.id = a
          this.form.a_customer_id = this.a_customer_id
          this.category = res.data.data.categoryList
          this.type = this.form.type
          this.disabled=true
        })
      } else {
        this.form.id = ''
        this.disabled=false
      }
    }
  },
  mounted() {
    this.getFormData()
  },
  methods: {
    getFormData() {
      API.service.ADD_DATA({a_customer_id: this.a_customer_id}).then(res => {
        this.form = res.data.data
        this.form.a_customer_id = this.a_customer_id
        this.category = res.data.data.categoryList
      })
    },
    onClose() {
      this.$emit("changVisible", false);
      this.formErr = {category_ids: ""}
      this.form.type = ""
      this.$refs.ruleForm.resetFields();
      this.form.m_news_category_id = [];
    },
    onSubmit() {
      let _this = this;
      // 只在 prop type 有效时才覆盖 form.type，否则保持 API 返回的原值
      if (this.type == 1 || this.type == 2) {
        this.form.type = this.type
      }
      if (this.type == 2) {
        this.form.m_news_category_id = []
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url
          this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
          console.log(_this.form)
          submitForm(url, _this.form).then(res => {
            if (res == true) {
              this.onClose()
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>

</style>
